<template>
  <div>
    <div id="aboutPanel" class="grid-side-space tabcontent">
      <div class="content">
        <p>{{ $t("about.main_text2") }}</p>
        <p>{{ $t("about.main_text3") }}</p>
        <p v-html="$t('about.main_text4')"></p>
      </div>
      <div class="content info">
       <ul>
          <li>
            <h4>{{ $t("default.company") }}</h4>
          </li>
          <li>
            <span>{{ $t("default.company_address") }}</span>
          </li>
          <li>
            <span>{{ $t("default.company_city") }}</span>
          </li>
          <li>
            <span>{{ $t("default.company_country") }}</span>
          </li>
        </ul>
        <ul>
          <li>
            <span>
              E:
              <a class="txt" v-bind:href="episcenterMailTo">{{episcenterMail}}</a>
            </span>
          </li>
          <li>
            <span>
              T:
              <a class="txt" v-bind:href="episcenterTelTo">{{episcenterTel}}</a>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      episcenterMailTo: "mailto:info@episcenterklub.si",
      episcenterMail: "info@episcenterklub.si",
      episcenterTelTo: "tel:38614702600",
      episcenterTel: "+386 1 470 26 00",
      notCompleted: true,
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>


<style>
</style>